import { createSlice } from "@reduxjs/toolkit";
import {
  requestPresignedUrl,
  uploadFileToS3,
  pollProcessingStatus,
  fetchAISummary,
  fetchUploadedFiles,
  deleteFile,
  downloadFile
} from "./thunk";

export const initialState = {
  uploadedFiles: [],
  totalCount:0,
  currentFile: null,
  uploadProgress: 0,
  processingStatus: null,
  aiSummary: null,
  preSignedData: null,
  listLoading: false,
  summaryLoading: false,
  deleteLoading: false,
  loading: false,
  error: null
};

const PdfSlice = createSlice({
  name: 'Pdf',
  initialState,
  reducers: {
    // Custom reducer for upload progress
    uploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    resetUpload: (state) => {
      state.currentFile = null;
      state.uploadProgress = 0;
      state.preSignedData = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    // Request Pre-signed URL
    builder.addCase(requestPresignedUrl.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(requestPresignedUrl.fulfilled, (state, action) => {
      state.preSignedData = action?.payload;
      state.loading = false;
    });
    builder.addCase(requestPresignedUrl.rejected, (state, action) => {
      state.error = action?.payload || 'Failed to get upload URL';
      state.loading = false;
    });

    // Upload File to S3
    builder.addCase(uploadFileToS3.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(uploadFileToS3.fulfilled, (state, action) => {
      state.currentFile = action?.payload;
      state.loading = false;
      state.uploadProgress = 100;
    });
    builder.addCase(uploadFileToS3.rejected, (state, action) => {
      state.error = action?.payload || 'Upload failed';
      state.loading = false;
    });

    // Poll Processing Status
    builder.addCase(pollProcessingStatus.fulfilled, (state, action) => {
      state.processingStatus = action?.payload;
    });
    builder.addCase(pollProcessingStatus.rejected, (state, action) => {
      state.error = action?.payload || 'Status check failed';
    });

    // Fetch AI Summary
    builder.addCase(fetchAISummary.pending, (state) => {
      state.summaryLoading = true;
    });
    builder.addCase(fetchAISummary.fulfilled, (state, action) => {
      state.aiSummary = action?.payload;
      state.summaryLoading = false;
    });
    builder.addCase(fetchAISummary.rejected, (state, action) => {
      state.error = action?.payload || 'Summary fetch failed';
      state.summaryLoading = false;
    });

    // Fetch Uploaded Files
    builder.addCase(fetchUploadedFiles.pending, (state) => {
      state.listLoading = true;
      state.error = null; // Clear error when starting a new fetch
    });
    builder.addCase(fetchUploadedFiles.fulfilled, (state, action) => {
      state.uploadedFiles = action?.payload?.documents || [];
      state.totalCount = action?.payload?.total_count || 0;
      state.listLoading = false;
      state.error = null; // Clear error on success
    });
    builder.addCase(fetchUploadedFiles.rejected, (state, action) => {
      state.error = action?.payload || 'Failed to load files';
      state.listLoading = false;
    });

    // Delete File

    builder.addCase(deleteFile.pending, (state) => {
      state.deleteLoading = true;
    });


    builder.addCase(deleteFile.fulfilled, (state, action) => {
      state.uploadedFiles = state.uploadedFiles.filter(
        file => file.document_id !== action?.payload?.fileId
      );
      state.deleteLoading = false;
    });
    builder.addCase(deleteFile.rejected, (state, action) => {
      state.error = action?.payload || 'Delete failed';
      state.deleteLoading = false;
    });

    // Download File
    builder.addCase(downloadFile.rejected, (state, action) => {
      state.error = action?.payload || 'Download failed';
    });
  }
});

export const { uploadProgress, resetUpload, clearError } = PdfSlice.actions;
export default PdfSlice.reducer;
